"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoToJSON = exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSONTyped = exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSON = exports.instanceOfReasonsForTestingIndicationStructuredProbandConditionsDto = exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoNameEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoNameEnum = {
    BreastCancer: 'Breast cancer',
    ColonRectalCancer: 'Colon/rectal cancer',
    ColonRectalPolyps: 'Colon/rectal polyps',
    EndometrialUterineCancer: 'Endometrial/uterine cancer',
    LynchSyndromeRiskModelScore: 'Lynch Syndrome risk model score',
    OtherCancer: 'Other cancer',
    OvarianFallopianTubePrimaryPeritonealCancer: 'Ovarian/Fallopian tube/primary peritoneal cancer',
    PancreaticCancer: 'Pancreatic cancer',
    ProstateCancer: 'Prostate cancer',
    Null: 'null'
};
/**
 * Check if a given object implements the ReasonsForTestingIndicationStructuredProbandConditionsDto interface.
 */
function instanceOfReasonsForTestingIndicationStructuredProbandConditionsDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfReasonsForTestingIndicationStructuredProbandConditionsDto = instanceOfReasonsForTestingIndicationStructuredProbandConditionsDto;
function ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSON(json) {
    return ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSONTyped(json, false);
}
exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSON = ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSON;
function ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'ageAtDiagnosis': !(0, runtime_1.exists)(json, 'ageAtDiagnosis') ? undefined : json['ageAtDiagnosis'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'statuses': !(0, runtime_1.exists)(json, 'statuses') ? undefined : json['statuses'],
    };
}
exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSONTyped = ReasonsForTestingIndicationStructuredProbandConditionsDtoFromJSONTyped;
function ReasonsForTestingIndicationStructuredProbandConditionsDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'ageAtDiagnosis': value.ageAtDiagnosis,
        'description': value.description,
        'statuses': value.statuses,
    };
}
exports.ReasonsForTestingIndicationStructuredProbandConditionsDtoToJSON = ReasonsForTestingIndicationStructuredProbandConditionsDtoToJSON;
